import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 20 16"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M.5 8a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .416.223L8.268 10.5h3.464l1.852-2.777A.5.5 0 0 1 14 7.5h5a.5.5 0 0 1 0 1h-4.732l-1.852 2.777A.5.5 0 0 1 12 11.5H8a.5.5 0 0 1-.416-.223L5.732 8.5H1A.5.5 0 0 1 .5 8",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M4.344 1.558 1 8.236V14a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V8.236l-3.345-6.681A1 1 0 0 0 14.76 1H5.24a1 1 0 0 0-.894.555zM5.24 0h9.52a2 2 0 0 1 1.79 1.11L20 8v6a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V8l3.45-6.89A2 2 0 0 1 5.24 0",
      clipRule: "evenodd"
    }
  )
);
var SvgInboxOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var InboxOutlined_default = SvgInboxOutlined;

export { InboxOutlined_default as default };
